import { MainNavigationComponent } from './components/main-navigation/main-navigation.component';
import { NotificationContainerComponent } from './components/notification-container/notification-container.component';
import { SwUpdateService } from './core/services/service-worker/sw-update.service';
import { StateService } from './core/services/state/state.service';
import { HeaderComponent } from './header/header.component';
import { Component, DestroyRef, inject, signal, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs/operators';

const MAIN_NAVIGATION_ROUTE_PREFIXES = ['/home', '/orders/to-be-scheduled', '/calendar', '/auditors', '/auditor'] as const;

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, HeaderComponent, MainNavigationComponent, NotificationContainerComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  public readonly showHeader = this._stateService.showHeader;
  public readonly isLoggedIn = this._stateService.isLoggedIn;
  public readonly showMainNavigation = signal(false);

  private readonly _destroyRef = inject(DestroyRef);
  private readonly _router = inject(Router);

  public constructor(
    private readonly _stateService: StateService,
    private readonly _swUpdateService: SwUpdateService
  ) {
    this._swUpdateService.init();
    this._updateMainNavigationVisibility(this._router.url);

    this._router.events
      .pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
        takeUntilDestroyed(this._destroyRef)
      )
      .subscribe((event): void => {
        this._updateMainNavigationVisibility(event.urlAfterRedirects);
      });
  }

  public get showHeaderSignal(): boolean {
    const currentUrl = location.pathname;
    const isAuthenticated = this.isLoggedIn();

    return isAuthenticated && currentUrl !== '/login';
  }

  private _updateMainNavigationVisibility(url: string): void {
    this.showMainNavigation.set(this.isLoggedIn() && this._isMainNavigationRoute(url));
  }

  private _isMainNavigationRoute(url: string): boolean {
    const path = url.split('?')[0]?.split('#')[0] ?? '';

    return MAIN_NAVIGATION_ROUTE_PREFIXES.some((route): boolean => path === route || path.startsWith(`${route}/`));
  }
}
